import { Button, message, Modal, Space } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { ASSIGNEE_TYPE } from '../../../constants'
import SelectPeoplePopup from '../../../components/SelectPeoplePopup'
import { SelectPeopleWrapper } from '../PopupVote/PopupVoteStyled'
import SelectUserButton from '../../../components/Common/SelectUserButton'
import SelectListComponent from '../../../components/Common/SelectListComponent'

const PopupAddEditPersonVoteV2 = props => {
  const {
    isOpenModal,
    setIsOpenModal,
    selectPeopleStore,
    loadingAnimationStore,
    voteStore,
    workStore,
  } = props

  const {
    selectUserData,
    selectDepartmentData,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    assigneePopupType,
    clearSelectUserData,
  } = selectPeopleStore
  const { workDetail } = workStore
  const { assignees, title, code } = workDetail
  const { voteDetail } = voteStore
  const [voterList, setVoterList] = useState([])

  const handleCancelModal = () => {
    setIsOpenModal(false)
    clearSelectUserData()
  }

  useEffect(() => {
    if (!assigneePopupType) return
    setVoterList([
      ...selectUserData[assigneePopupType],
      ...selectDepartmentData[assigneePopupType],
    ])
  }, [selectUserData, selectDepartmentData, assigneePopupType])

  useEffect(() => {
    if (!isOpenModal) return

    selectPeopleStore.setAssigneePopupType(ASSIGNEE_TYPE.USER)
    selectPeopleStore.setSelectUserData(
      selectPeopleStore.convertSelectDataObj(voteStore?.voteDetail)
    )

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenModal, voteStore?.voteDetail])

  const handleSubmitSelectVoter = async () => {
    try {
      loadingAnimationStore.showSpinner(true)
      const handlerList = assignees.filter(
        el =>
          el.permission === ASSIGNEE_TYPE.HANDLER &&
          el.assignee_code !== 'admin' &&
          el.assignee_type === 'USER'
      )
      const newVoterList = voterList.map(voter => ({ assignee_code: voter.id }))
      const newHandlerList = voterList
        .map(voter => ({ ...voter, assignee_code: voter.id }))
        .filter(
          voter =>
            !handlerList.some(
              handler => handler.assignee_code === voter.assignee_code
            )
        )
      const remove_items = voteDetail
        .map(voter => ({ assignee_code: voter.assignee_code }))
        .filter(
          prev =>
            !newVoterList.some(
              voter => voter.assignee_code === prev.assignee_code
            )
        )
      const new_items = newVoterList.filter(
        voter =>
          !voteDetail.some(prev => prev.assignee_code === voter.assignee_code)
      )

      const data = {
        document_code: code,
        document_title: title,
        type: 'WORK',
        vote_users: {
          remove_items: remove_items,
          new_items: new_items,
        },
        current_assignee: handlerList.concat(newHandlerList),
      }

      if (
        data.vote_users.new_items.length > 0 ||
        data.vote_users.remove_items.length > 0
      ) {
        if (voteDetail?.length > 0) {
          await voteStore.updatePersonVote(code, data)
        } else {
          await voteStore.createVote(data)
        }
        await voteStore.getVoteDetail(code)
        await workStore.getWorkDetail(code)
        message.success('Bạn đã cập nhật lấy ý kiến!')
        handleCancelModal()
      } else message.error('Bạn chưa chọn người lấy ý kiến')
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  return (
    <>
      <Modal
        title="Chọn người lấy ý kiến"
        width={650}
        wrapClassName="custom-modal-wrapper"
        maskClosable={false}
        open={isOpenModal}
        onCancel={handleCancelModal}
        footer={null}
        destroyOnClose>
        <div>
          <SelectUserButton
            handleOnClick={() => {
              setIsVisibleSelectUserDepartmentPopup(true)
              handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.USER)
            }}
          />
          <SelectListComponent userList={voterList} />
        </div>

        <div className="custom-modal-footer" style={{ marginTop: 24 }}>
          <Space>
            <Button
              danger
              className="custom-ant-button w-160"
              onClick={() => {
                handleCancelModal()
              }}>
              Hủy
            </Button>
            <Button
              className="custom-ant-button w-160"
              type={'primary'}
              onClick={() => handleSubmitSelectVoter()}>
              Cập nhật
            </Button>
          </Space>
        </div>
        <SelectPeoplePopup
          disableSelectDepartment
          handleCancelSelectUser={() =>
            setIsVisibleSelectUserDepartmentPopup(false)
          }
          handleSubmitSelectUser={() =>
            setIsVisibleSelectUserDepartmentPopup(false)
          }
          isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
        />
      </Modal>
    </>
  )
}

export default inject(
  'workStore',
  'voteStore',
  'selectPeopleStore',
  'loadingAnimationStore'
)(observer(PopupAddEditPersonVoteV2))
